import { AreaChart, Area, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import GlassCard from '@/components/base/GlassCard';
import KpiCard from '@/components/base/KpiCard';
import { revenueData, topEarningExperts, serviceRevenueData } from '@/mocks/dashboardData';

const RevenuePage: React.FC = () => (
  <div>
    <div className="mb-5">
      <h1 className="text-xl font-bold text-white" style={{ fontFamily: 'Inter, sans-serif' }}>Gelir Analizi</h1>
      <p className="text-xs mt-0.5" style={{ color: '#6b7280' }}>Günlük, aylık gelir ve komisyon verileri</p>
    </div>
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-5">
      <KpiCard label="Bugünkü Gelir" value="48.750" change={22.3} icon="ri-money-dollar-circle-line" suffix=" ₺" />
      <KpiCard label="Aylık Gelir" value="876.000" change={18.5} icon="ri-bar-chart-2-line" suffix=" ₺" />
      <KpiCard label="Komisyon (%30)" value="262.800" change={18.5} icon="ri-percent-line" suffix=" ₺" />
      <KpiCard label="Ort. İşlem" value="750" change={5.2} icon="ri-exchange-funds-line" suffix=" ₺" />
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">
      <GlassCard className="lg:col-span-2" title="Günlük Gelir Trendi" subtitle="Son 14 gün">
        <ResponsiveContainer width="100%" height={220}>
          <AreaChart data={revenueData}>
            <defs>
              <linearGradient id="revGrad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#ff4d4d" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#ff4d4d" stopOpacity={0} />
              </linearGradient>
              <linearGradient id="comGrad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#ff8c42" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#ff8c42" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" />
            <XAxis dataKey="gun" tick={{ fill: '#6b7280', fontSize: 10 }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fill: '#6b7280', fontSize: 10 }} axisLine={false} tickLine={false} tickFormatter={(v) => `${(v/1000).toFixed(0)}k`} />
            <Tooltip contentStyle={{ background: '#1a1a2e', border: '1px solid rgba(255,77,77,0.3)', borderRadius: '8px', fontSize: '12px' }} formatter={(v: number) => [`${v.toLocaleString('tr-TR')} ₺`]} />
            <Area type="monotone" dataKey="gunluk" name="Gelir" stroke="#ff4d4d" strokeWidth={2} fill="url(#revGrad)" />
            <Area type="monotone" dataKey="komisyon" name="Komisyon" stroke="#ff8c42" strokeWidth={2} fill="url(#comGrad)" />
          </AreaChart>
        </ResponsiveContainer>
      </GlassCard>
      <GlassCard title="Hizmet Bazlı Gelir" subtitle="₺ cinsinden">
        <ResponsiveContainer width="100%" height={220}>
          <BarChart data={serviceRevenueData} layout="vertical">
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" />
            <XAxis type="number" tick={{ fill: '#6b7280', fontSize: 10 }} axisLine={false} tickLine={false} tickFormatter={(v) => `${(v/1000).toFixed(0)}k`} />
            <YAxis type="category" dataKey="hizmet" tick={{ fill: '#9ca3af', fontSize: 10 }} axisLine={false} tickLine={false} width={70} />
            <Tooltip contentStyle={{ background: '#1a1a2e', border: '1px solid rgba(255,77,77,0.3)', borderRadius: '8px', fontSize: '12px' }} formatter={(v: number) => [`${v.toLocaleString('tr-TR')} ₺`]} />
            <Bar dataKey="gelir" name="Gelir" radius={[0, 4, 4, 0]} fill="url(#srvGrad)" />
            <defs>
              <linearGradient id="srvGrad" x1="0" y1="0" x2="1" y2="0">
                <stop offset="0%" stopColor="#ff4d4d" /><stop offset="100%" stopColor="#ff8c42" />
              </linearGradient>
            </defs>
          </BarChart>
        </ResponsiveContainer>
      </GlassCard>
    </div>
    <GlassCard title="En Çok Kazanan Uzmanlar" subtitle="Bu ay">
      <div className="space-y-3">
        {topEarningExperts.map((e, idx) => (
          <div key={e.isim} className="flex items-center gap-3 p-3 rounded-lg" style={{ background: 'rgba(255,255,255,0.03)' }}>
            <div className="w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold text-white flex-shrink-0" style={{ background: idx === 0 ? 'linear-gradient(135deg,#ffd700,#ffaa00)' : idx === 1 ? 'linear-gradient(135deg,#c0c0c0,#909090)' : 'linear-gradient(135deg,#ff4d4d,#ff8c42)' }}>{idx + 1}</div>
            <div className="flex-1"><div className="text-sm font-medium text-white">{e.isim}</div><div className="text-xs" style={{ color: '#6b7280' }}>{e.sehir} · {e.is} iş</div></div>
            <div className="text-right"><div className="text-sm font-bold text-white" style={{ fontFamily: 'JetBrains Mono, monospace' }}>{e.kazanc.toLocaleString('tr-TR')} ₺</div><div className="text-xs" style={{ color: '#10b981' }}>+%{(Math.random() * 20 + 10).toFixed(1)}</div></div>
          </div>
        ))}
      </div>
    </GlassCard>
  </div>
);

export default RevenuePage;
